export enum SortingOptionsValues {
  LATEST = '',
  POPULAR = '-views',
}
